import { componentsConfig as defaultConfig } from "srs.sharedcomponents/lib/esm/components/config";
import WelcomeBuilder from "srs.sharedcomponents/lib/esm/components/organisms/Welcome/BuilderContent/WelcomeBuilder"

const componentsConfig = { ...defaultConfig, WelcomeContent: WelcomeBuilder };

export { componentsConfig };